class UrlManager {
    setUrlParams = (params, remove_empty = false, remove_page = true) => {
        const searchParams = new URLSearchParams(window.location.search);
        params.forEach(({ param, value }) => {
            if (remove_empty && (value == '' || value == undefined || !value.length)) {
                searchParams.delete(param);
            } else {
                searchParams.set(param, value);
            }
        });
        this.applyParamsToUrl(searchParams, remove_page);
    };

    setUrlParam = ({ param, value }) => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set(param, value);
        this.applyParamsToUrl(searchParams);
    };

    removeUrlParam = (param) => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.delete(param);
        this.applyParamsToUrl(searchParams);
    };

    applyParamsToUrl = (searchParams, remove_page = true) => {
        let url_path = window.location.href.split('?')[0];
        if (remove_page) {
            url_path = url_path.split('page')[0];
        }
        const url = new URL(`${url_path}?${searchParams.toString()}`);
        history.pushState(url.toString(), '', url.toString());
    };

    getUrlParam = (param) => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get(param);
    };
}

export { UrlManager };
